<template>
  <div class="identifyResult">
    <vue-draggable-resizable
      drag-handle=".ant-card-head"
      class="wrap container"
      :w="dragW"
      :h="dragH"
      v-if="
        resultVisible &&
        (identifyLayerResult.length > 1 || allResults.length > 1)
      "
    >
      <!-- <div class="container"> -->
      <a-card class="identify-result">
        <!-- <a-card v-show="resultVisible" class="identify-result"> -->
        <!-- <a-icon slot="extra" type="close" @click="handleClose"/> -->
        <div class="boxClose">
          <img
            :src="require('@/assets/images/poscloseIcon.png')"
            style="cursor: pointer"
            @click="handleClose()"
          />
        </div>
        <span slot="title">
          共<a href="#" style="color: rgb(255, 0, 0)">{{
            identifyLayerResult.length
          }}</a
          >个图层
          <a href="#" style="color: rgb(255, 0, 0)">{{ allResults.length }}</a
          >条查询结果
        </span>
        <a-form-model
          layout="horizontal"
          :labelCol="{ span: 6 }"
          :wrapperCol="{ span: 18 }"
        >
          <a-form-model-item label="结果图层">
            <div class="selectBox" ref="selectBox">
              <a-select
                v-model="currentLayer"
                :getPopupContainer="() => this.$refs.selectBox"
                placeholder="识别结果图层"
                @change="handleSelect"
              >
                <a-select-option
                  v-for="(item, index) in identifyLayerResult"
                  :key="index"
                  :value="item.layerTitle"
                  :info="item"
                >
                  {{ item.layerTitle }}
                </a-select-option>
              </a-select>
            </div>
          </a-form-model-item>
        </a-form-model>
        <a-list
          class="search-result-list"
          item-layout="horizontal"
          size="small"
          :data-source="currentLayerResult"
        >
          <a-list-item
            v-if="!item.pointCoor"
            slot="renderItem"
            slot-scope="item"
          >
            <a-list-item-meta>
              <span slot="title">{{ item.properties.OBJECTID }}</span>
            </a-list-item-meta>
            <img
              slot="actions"
              :src="require('@/assets/images/topositionIcon.png')"
              style="cursor: pointer"
              @click="doPosition(item, {}, true)"
            />
            <img
              slot="actions"
              :src="require('@/assets/images/helpIcon.png')"
              style="cursor: pointer"
              @click="doPosition(item, { isPopup: true }, false)"
            />
            <!-- <a-icon slot="actions" type="environment" @click="doPosition(item,{},true)" /> -->
            <!-- <a-icon slot="actions" type="info-circle" @click="doPosition(item, { isPopup: true },false)" /> -->
          </a-list-item>
          <a-list-item v-else slot="renderItem" slot-scope="item">
            <a-list-item-meta>
              <span slot="title">{{ item.layerName }}{{ item.id }}</span>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </a-card>
    </vue-draggable-resizable>
    <div
      :style="{
        position: 'absolute',
        top:
          resultVisible &&
          (identifyLayerResult.length > 1 || allResults.length > 1)
            ? '265px'
            : '45px',
      }"
    >
      <map-detail-card ref="detailCard"></map-detail-card>
    </div>
  </div>
</template>

<script>
import MapDetailCard from "../../../components/MapDetailCard.vue";
let drawGraphic;
let map;
let geoJsonLayer;
export default {
  name: "IdentifyResult",
  components: { MapDetailCard },
  data() {
    return {
      dragW: 500,
      dragH: 230,
      resultVisible: false, // 页面是否显示
      identifyLayerResult: [], // 识别的所有图层(name,layerTitle)
      currentLayerResult: [], // 下拉框选择的图层对应的识别结果
      allResults: [],
      resultLength: 0, // 所有图层识别出来的结果数
      currentLayer: "", // 下拉框选择的图层名称
      promiseArr: [],
      allLayers: [], // 地图的所有图层
      currentLayerUrl: "", // 下拉框选择的图层的url
      highlightArea: {},
      graphicLayer: null, //矢量实体
      polyGraphicLayer: null,
      polyGraphic: null,
      latlngs: [],
      selectKey: "",
      selectedNode: null,
      escCount: 0, //记录清除次数
      selectedGeom: null,
    };
  },
  watch: {
    resultVisible(newVal) {
      if (!newVal) {
        this.$refs.detailCard.close();
      }
    },
    currentLayerResult(newVal, oldVal) {
      // console.log('newVal',newVal);
      if (newVal && newVal.length === 1) {
        this.dragH = 150;
      } else if (newVal && newVal.length === 2) {
        this.dragH = 190;
      } else {
        this.dragH = 220;
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    //监听键盘事件
    handleKeydown(event) {
      if (event.keyCode === 27) {
        this.escCount++;
        if (this.resultVisible) {
          this.handleClose();
        } else {
          this.$refs.detailCard.close();
        }
      }
    },
    /**
     * 识别方法
     * @param {Objet} selectedNode  选中的当前层信息
     */
    identify(e, cmap, selectedNode) {
      this.clearAll("pick_clear");
      map = cmap;
      console.log("identify", e, map);
      console.log("选中的节点", selectedNode);
      this.allLayers = map
        .getLayers()
        .filter(
          (layer) =>
            layer.options.url &&
            layer.options.serviceType &&
            layer.options.serviceType != "Tile"
        );
      console.log("所有图层", this.allLayers,map.getLayers());
      // 重新点击识别，做清空处理
      this.currentLayer = "";
      this.highlightArea = {};
      this.identifyLayerResult = [];
      this.currentLayerResult = [];
      this.allResults = [];
      this.promiseArr = [];
      this.resultVisible = false;
      // if(this.$refs.detailCard){
      this.$refs.detailCard.close();
      // }
      const key = e.key;
      this.pickIdentify(key, selectedNode);
      // if (key === "pick_clear") {
      //   // console.log('pick_clear',key);
      //   // 清除
      //   this.clearAll(key);
      // } else if (key.indexOf("select") > -1) {
      //   // 识别当前层
      //   if (!selectedNode) {
      //     this.$message.warning("暂无选中图层！");
      //   } else if (
      //     selectedNode.layerGroup == 0 ||
      //     selectedNode.layerGroup == 1
      //   ) {
      //     this.$message.warning("请选择单张图层！");
      //   } else {
      //     if (key == "pick_select") {
      //       // 单击
      //       this.pickIdentify(key, selectedNode);
      //     } else {
      //       // 框选
      //       geoJsonLayer = new this.mars3d.layer.GeoJsonLayer({
      //         name: "GeoJson识别高亮图层",
      //         symbol: {
      //           type: "polygonP",
      //           styleOptions: {
      //             color: "rgba(205, 233, 247, 0.7)", // 填充颜色
      //             clampToGround: false,
      //           },
      //         },
      //       });
      //       map.addLayer(geoJsonLayer);
      //       this.createRectangle(key, selectedNode);
      //     }
      //   }
      // } else if (key.indexOf("visible") > -1) {
      //   // 识别可见层
      //   if (key == "pick_visible") {
      //     // 单击
      //     this.pickIdentify(key);
      //   } else {
      //     // 框选
      //     geoJsonLayer = new this.mars3d.layer.GeoJsonLayer({
      //       name: "GeoJson识别高亮图层",
      //       symbol: {
      //         type: "polygonP",
      //         styleOptions: {
      //           color: "rgba(205, 233, 247, 0.7)", // 填充颜色
      //           clampToGround: false,
      //         },
      //       },
      //     });
      //     map.addLayer(geoJsonLayer);
      //     this.createRectangle(key);
      //   }
      // }
    },
    /**
     * 点击单击识别 执行的方法
     * @param {String} key  选择的点击类型（单击识别当前层、所见层、框选识别当前层、所见层）
     */
    pickIdentify(key, selectedNode) {
      console.log("pickIdentify", key);
      this.selectKey = key;
      this.selectedNode = selectedNode;
      this.mousedownFunction = this.pickIdentifyPromise;
      map.on(mars3d.EventType.click, this.mousedownFunction, this);

      // this.mouseupFunction = this.finishRectangle
      // map.on('mouseup', this.mouseupFunction)
      // this.pickIdentifyPromise(key,selectedNode).then(res => {
      //   // 解除图层绑定的点击事件，否则先单击识别，再框选识别时，仍然走pickIdentifyPromise里的方法
      //   map.getLayers().map(item => {
      //     item.off(mars3d.EventType.click)
      //   })
      // this.selectDefaultLayer()
      // })
    },
    /**
     * 单击识别 调用火星的方法
     */
    pickIdentifyPromise(e) {
      const that = this;
      if (this.polyGraphicLayer) {
        map.removeLayer(this.polyGraphicLayer);
        map.getLayers().forEach((layer) => {
          if (
            layer.id !== this.polyGraphicLayer.id &&
            layer.type == "graphic"
          ) {
            map.removeLayer(layer);
          }
        });
      }

      map.getLayers().forEach(item=>{
        item.show && this.allLayers.push(item)
      })

      console.log(
        "pickIdentifyPromise",
        e,
        this.selectedNode,
        map.getLayers(),
        map.scene.primitives,
        this.polyGraphicLayer,
        this.graphicLayer
      );
      const scene = map.scene;

      // 识别结果的高亮图层
      this.polyGraphicLayer = new mars3d.layer.GraphicLayer();
      map.addLayer(this.polyGraphicLayer);

      let style =
        this.selectedNode && this.selectedNode.layerStyle
          ? JSON.parse(this.selectedNode.layerStyle)
          : null;
      // 这里关于水体识别的判断可能后续还需要优化，因为关于水体的渲染是不在map的layers中的
      if (
        this.selectedNode &&
        this.selectedNode.loadType == "GeoJson" &&
        (this.selectedNode.title.includes("水体") ||
          style.styleSpecificType == "waterPolygon") &&
        scene.primitives._primitives.length > 1
      ) {
        const that = this;
        let currentObjectid;
        let currentPrimitive;
        let currentGeometry;
        let attributes;
        const pickObject = e.pickedObject;

        if (Cesium.defined(pickObject) && Cesium.defined(pickObject.id)) {
          console.log(pickObject);
          if (pickObject.id === currentObjectid) {
            return;
          }

          if (Cesium.defined(currentObjectid)) {
            currentObjectid = undefined;
            currentPrimitive = undefined;
          }
        }

        if (
          Cesium.defined(pickObject) &&
          Cesium.defined(pickObject.id) &&
          Cesium.defined(pickObject.primitive)
        ) {
          console.log(pickObject, that.selectedGeom);
          if (that.selectedGeom) {
            scene.primitives.remove(that.selectedGeom);
          }

          currentObjectid = pickObject.id;
          currentPrimitive = pickObject.primitive;
          currentGeometry = currentPrimitive.geometryInstances.find(
            (item) => item.id === currentObjectid
          );

          that.selectedGeom = new Cesium.Primitive({
            geometryInstances: currentGeometry,
            releaseGeometryInstances: false,
            appearance: new Cesium.PerInstanceColorAppearance({
              flat: true,
            }),
            show: true,
          });
          scene.primitives.add(that.selectedGeom);
          currentPrimitive.appearance.material.uniforms.baseWaterColor =
            style && style.hightlight
              ? style.baseColorHL
              : new Cesium.Color(0, 0.4, 0.7, 0.7);
          // currentPrimitive.appearance.material.uniforms.baseWaterColor =
          //   new Cesium.Color(0, 0.4, 0.7, 0.7);
        } else if (Cesium.defined(currentObjectid)) {
          currentObjectid = undefined;
          currentPrimitive = undefined;
        }

        mars3d.Util.fetchJson({
          url: this.selectedNode.layerUrl,
          queryParameters: {
            FeatureID: currentObjectid,
          },
        }).then((response) => {
          let alias = this.selectedNode.attributes;
          let attr = response.features[0].properties;
          console.log(attr);
          let arr = [];
          let attributeArr = [];
          arr = Object.keys(attr).map((val) => ({
            key: val,
            value: attr[val],
            show: true,
          }));
          arr.forEach((a) => {
            this.selectedNode.attributes.forEach((alias) => {
              if (a.key == alias.name.toLowerCase()) {
                let obj = {
                  key: a.key,
                  value: a.value,
                  show: a.show,
                  alias: alias.alias,
                  orderNo: alias.orderNo,
                  type: "mvt",
                };
                attributeArr.push(obj);
              }
            });
          });
          this.$refs.detailCard.openDetail(attributeArr, "");
        });
      }
      // 区分是点击当前层还是点击所有层
      this.pickVisibleAndSelect(e);
      /*
      if(this.selectKey == "pick_visible"){
        // 识别所有层
        let dupliArr = []
        map.getLayers().forEach(item=>{
          if(item.type == 'mvt'){
            item.imageryProvider.featuresPicked.addEventListener(function (
              imageryProvider,
              pickedFeatures
            ) {
              pickedFeatures[0].layerName = imageryProvider.options.name;
              pickedFeatures[0].layerId = imageryProvider.options.id;
              pickedFeatures[0].attributes = imageryProvider.options.attributes;

              console.log('识别所有层',pickedFeatures,imageryProvider);
              dupliArr.push(imageryProvider)
              
              if (pickedFeatures.length > 0) {
                that.showDetails(pickedFeatures,imageryProvider);
              }              
              // pickedFeatures[0].id.split('.')[0]
              var layerArr = that.identifyLayerResult.filter(
                (result) =>
                  result.layerName == pickedFeatures[0].layerName
              );
              if(layerArr.length == 0){
                var obj = {
                  layerTitle: imageryProvider.options.name,
                  layerName: imageryProvider.options.name,
                  serviceUrl: imageryProvider.options.url,
                }
                that.identifyLayerResult.push(obj)
              }
              // _this.identifyLayerResult = Array.from(new Set(dupliArr))
              if (that.identifyLayerResult.length > 0) {
                //得到目前的图层
                that.currentLayer = that.identifyLayerResult.filter(
                  (result) =>
                    result.layerName == pickedFeatures[0].layerName
                )[0].layerName;
              }
              //这部分的代码不能放到showDetails里，否则allResults就被压入了无限多的item导致异常溢出，因为下拉框也用到了showDetails
              //主要是上部对话框里面的list进行展示
              var identifyData = that.allResults.filter(
                (result) =>
                  result[0].layerName == pickedFeatures[0].layerName &&
                  result[0].id == pickedFeatures[0].id
              );

              if (identifyData.length == 0) {
                that.allResults.push(pickedFeatures);
              }

              if (that.identifyLayerResult.length > 1) {
                that.resultVisible = true;
                that.currentLayerResult = that.allResults.filter(
                  (result) =>
                    result[0].layerName == that.currentLayer
                )[0];
                console.log('that.currentLayerResult',that.currentLayerResult);
              }
              console.log('_this.identifyLayerResult',that.identifyLayerResult)
            })
          }
        })
      }else if(this.selectKey == "pick_select"){
        map.getLayers().forEach(item=>{
          if(item.type == 'mvt'){
            item.imageryProvider.featuresPicked.addEventListener(function (
              imageryProvider,
              pickedFeatures
            ) {
              pickedFeatures[0].layerName = imageryProvider.options.name;
              pickedFeatures[0].layerId = imageryProvider.options.id;
              pickedFeatures[0].attributes = imageryProvider.options.attributes;
              console.log('pickedFeatures',pickedFeatures);
              // 在识别的所有结果里 筛选出 和选中图层的名称和id一样的
              var results = pickedFeatures.filter(
                (item) =>
                  item.layerId == that.selectedNode.key &&
                  (item.layerName == that.selectedNode.name ||
                    item.layerName == that.selectedNode.title)
              );
              console.log("result", results);
              if (results.length > 0) {
                that.showDetails(results);
              }
            })
          }
        })
      }
      */
      return;
      // 这里关于水体识别的判断可能后续还需要优化，因为关于水体的渲染是不在map的layers中的
      if (
        this.selectedNode &&
        this.selectedNode.loadType == "GeoJson" &&
        (this.selectedNode.title.includes("水体") ||
          style.styleSpecificType == "waterPolygon") &&
        scene.primitives._primitives.length > 1
      ) {
        const that = this;
        let currentObjectid;
        let currentPrimitive;
        let currentGeometry;
        let attributes;
        return new Promise((resolve) => {
          const pickObject = e.pickedObject;

          if (Cesium.defined(pickObject) && Cesium.defined(pickObject.id)) {
            console.log(pickObject);
            if (pickObject.id === currentObjectid) {
              return;
            }

            if (Cesium.defined(currentObjectid)) {
              currentObjectid = undefined;
              currentPrimitive = undefined;
            }
          }

          if (
            Cesium.defined(pickObject) &&
            Cesium.defined(pickObject.id) &&
            Cesium.defined(pickObject.primitive)
          ) {
            console.log(pickObject, that.selectedGeom);
            if (that.selectedGeom) {
              scene.primitives.remove(that.selectedGeom);
            }

            currentObjectid = pickObject.id;
            currentPrimitive = pickObject.primitive;
            currentGeometry = currentPrimitive.geometryInstances.find(
              (item) => item.id === currentObjectid
            );

            that.selectedGeom = new Cesium.Primitive({
              geometryInstances: currentGeometry,
              releaseGeometryInstances: false,
              appearance: new Cesium.PerInstanceColorAppearance({
                flat: true,
              }),
              show: true,
            });
            scene.primitives.add(that.selectedGeom);
            currentPrimitive.appearance.material.uniforms.baseWaterColor =
              style && style.hightlight
                ? style.baseColorHL
                : new Cesium.Color(0, 0.4, 0.7, 0.7);
            // currentPrimitive.appearance.material.uniforms.baseWaterColor =
            //   new Cesium.Color(0, 0.4, 0.7, 0.7);
          } else if (Cesium.defined(currentObjectid)) {
            currentObjectid = undefined;
            currentPrimitive = undefined;
          }

          mars3d.Util.fetchJson({
            url: this.selectedNode.layerUrl,
            queryParameters: {
              FeatureID: currentObjectid,
            },
          }).then((response) => {
            let alias = this.selectedNode.attributes;
            let attr = response.features[0].properties;
            console.log(attr);
            let arr = [];
            let attributeArr = [];
            arr = Object.keys(attr).map((val) => ({
              key: val,
              value: attr[val],
              show: true,
            }));
            arr.forEach((a) => {
              this.selectedNode.attributes.forEach((alias) => {
                if (a.key == alias.name.toLowerCase()) {
                  let obj = {
                    key: a.key,
                    value: a.value,
                    show: a.show,
                    alias: alias.alias,
                    orderNo: alias.orderNo,
                    type: "mvt",
                  };
                  attributeArr.push(obj);
                }
              });
            });
            this.$refs.detailCard.openDetail(attributeArr, "");
          });
          resolve(true);
        });
      } else if (map.getLayers().length !== 0) {
        return new Promise((resolve) => {
          map.getLayers().map((item) => {
            // console.log('单击识别item',item);
            if (item.type === "arcgis") {
              var serviceUrl = item.options.url;
              item.on(mars3d.EventType.click, (event) => {
                this.escCount = 0;
                console.log(
                  "单击了矢量数据，共" + event.features.length + "条",
                  event
                );
                if (this.selectKey == "pick_select") {
                  // 识别当前层
                  // 在识别的所有结果里 筛选出 和选中图层的名称和id一样的
                  var results = event.features.filter(
                    (item) =>
                      item.data.layerId == this.selectedNode.id &&
                      item.data.layerName == this.selectedNode.name
                  );

                  this.showData(results, serviceUrl, this.selectKey);
                  this.selectDefaultLayer();
                } else if (this.selectKey == "pick_visible") {
                  this.$refs.detailCard.close();
                  // 识别可见层
                  this.showData(event.features, serviceUrl, this.selectKey);
                  this.selectDefaultLayer();
                }
                resolve(true);
              });
            } else if (item.type === "mvt") {
              // console.log('mvt');
              this.escCount = 0;
              this.allResults = [];
              this.polyGraphicLayer = new mars3d.layer.GraphicLayer();
              map.addLayer(this.polyGraphicLayer);
              const that = this;
              let click = false;
              //显示mvt的弹窗和高亮
              item.imageryProvider.featuresPicked.addEventListener(function (
                imageryProvider,
                pickedFeatures
              ) {
                click = !click;
                // console.log("单击获取到的属性数据",pickedFeatures,imageryProvider)
                pickedFeatures[0].layerName = imageryProvider.options.name;
                pickedFeatures[0].layerId = imageryProvider.options.id;
                pickedFeatures[0].attributes =
                  imageryProvider.options.attributes;
                if (pickedFeatures.length > 0 && click) {
                  if (that.selectKey == "pick_select") {
                    console.log("pick_select", pickedFeatures);
                    // 识别当前层
                    // 在识别的所有结果里 筛选出 和选中图层的名称和id一样的
                    var results = pickedFeatures.filter(
                      (item) =>
                        item.layerId == that.selectedNode.key &&
                        (item.layerName == that.selectedNode.name ||
                          item.layerName == that.selectedNode.title)
                    );
                    console.log("result", results);
                    if (results.length > 0) {
                      that.showDetails(results);
                    }
                  } else if (that.selectKey == "pick_visible") {
                    console.log("pick_visible", pickedFeatures);
                    that.$refs.detailCard.close();
                    // console.log('默认的图层',that.identifyLayerResult);
                    var layerArr = that.identifyLayerResult.filter(
                      (result) =>
                        result.layerName == pickedFeatures[0].layerName
                    );

                    if (layerArr.length == 0) {
                      //组装识别结果的图层
                      var obj = {
                        // name:pickedFeatures[0].properties.dkmc || pickedFeatures[0].properties.dlmc,
                        layerTitle: imageryProvider.options.name,
                        layerName: imageryProvider.options.name,
                        serviceUrl: imageryProvider.options.url,
                      };
                      that.identifyLayerResult.push(obj);
                    }
                    if (that.identifyLayerResult.length > 0) {
                      //得到目前的图层
                      that.currentLayer = that.identifyLayerResult.filter(
                        (result) =>
                          result.layerName == pickedFeatures[0].layerName
                      )[0].layerName;
                    }

                    //这部分的代码不能放到showDetails里，否则allResults就被压入了无限多的item导致异常溢出，因为下拉框也用到了showDetails
                    //主要是上部对话框里面的list进行展示
                    var identifyData = that.allResults.filter(
                      (result) =>
                        result[0].layerName == pickedFeatures[0].layerName &&
                        result[0].id == pickedFeatures[0].id
                    );

                    if (identifyData.length == 0) {
                      that.allResults.push(pickedFeatures);
                    }

                    if (that.identifyLayerResult.length > 1) {
                      that.resultVisible = true;
                      that.currentLayerResult = that.allResults.filter(
                        (result) => result[0].layerName == that.currentLayer
                      )[0];
                      // console.log('that.currentLayerResult',that.currentLayerResult);
                    }
                    //end

                    // 识别所有层
                    if (pickedFeatures.length > 0) {
                      that.showDetails(pickedFeatures);
                    }
                  }
                  resolve(true);
                }
              });
            } else if (item.type === "3dtiles") {
              const that = this;
              console.log("3d3d", item, e);
              item.readyPromise.then(function (tileset) {
                console.log("load完成", tileset);
                let boundingSphere = tileset.boundingSphere;
                let cartographic = Cesium.Cartographic.fromCartesian(
                  boundingSphere.center
                );
                console.log("cartogrpahic", cartographic);
                let surface = Cesium.Cartesian3.fromRadians(
                  cartographic.longitude,
                  cartographic.latitude,
                  0.0
                );
                let offset = Cesium.Cartesian3.fromRadians(
                  cartographic.longitude,
                  cartographic.latitude,
                  cartographic.height + 200
                );
                var translation = Cesium.Cartesian3.subtract(
                  offset,
                  surface,
                  new Cesium.Cartesian3()
                );
                // item.setOptions({
                //   // style:{
                //     // "color":{
                //     //   "conditions":[
                //     //     ["${id}==='3dtile_feature_7'","color('#ff0000')"],
                //     //     ["true","color('#ffffff')"]
                //     //   ]
                //     // }
                //     // "show" : "${featureIdLabel} === '3dtile_feature_7'",
                //   // },
                //   modelMatrix:Cesium.Matrix4.fromTranslation(translation)
                // })
                // item.setOpacity(0.2)
                if (e.graphic.feature) {
                  // item.show = false
                  // item.style = new Cesium.Cesium3DTileStyle({
                  //   color:{
                  //     conditions:[
                  //       ["${objectid} === '" + e.graphic.attr.objectid + "'","rgb(255,255,255)"],
                  //       ["true","rgba(255,255,255,0.2)"],
                  //     ]
                  //   }
                  // })
                  let arr = [];
                  let attr = e.graphic.attr;
                  arr = Object.keys(attr).map((val) => ({
                    key: val,
                    value: attr[val],
                    show: true,
                  }));
                  that.$refs.detailCard.openDetail(arr, "水面属性查看");
                }
                // tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation)
                // tileset.updateMatrix2 = function(){
                //   return Cesium.Matrix4.fromTranslation(translation)
                // }
                // console.log('抬升后',tileset);
              });
            } else if (item.type === "GeoJson") {
              const that = this;
              // console.log('item',item);
              // item.on(mars3d.EventType.click, function (event) {
              //   console.log('点击')
              let pickFeature = e.pickedObject;
              pickFeature.layerId = e.layer.id;
              pickFeature.layerName = e.layer.name;
              that.escCount = 0;
              // console.log('点击',event);
              let arr = [];
              let attr = e.pickedObject.data.attr;
              console.log(attr);
              arr = Object.keys(attr).map((val) => ({
                key: val,
                value: attr[val],
                show: true,
              }));
              if (that.selectKey == "pick_select") {
                if (
                  pickFeature.layerId == that.selectedNode.key &&
                  pickFeature.layerName == that.selectedNode.name
                ) {
                  that.showWaterDetails(arr, e.pickedObject.data.positions);
                }
              } else if (that.selectKey == "pick_visible") {
                that.$refs.detailCard.close();
                that.showWaterDetails(arr, e.pickedObject.data.positions);
              }
              resolve(true);
              // })
            }
          });
        });
      }
    },

    pickVisibleAndSelect(e) {
      const that = this;
      // 以下两个参数用于图层结果和识别结果的临时/当前存储（否则会出现上次识别但地图上目前不可见的图层出现在结果列表中）
      let tempArray = []
      let tempResultArray = []
      // 这边还要再做一次移除，否则识别时就会把wms图层作为目标进行识别（暂不清楚原因）
      if(this.wmsLightLayer){
        map.removeLayer(this.wmsLightLayer)
      }
      // 遍历在map容器里面的所有可见的图层（以区分图层类型）
      that.allLayers.forEach((item) => {
        // 更新图层结果和识别详情
        if(that.allResults.length !== 0){
          that.allResults.forEach(result=>{
            if(result[0].layerName == item.name){
              tempResultArray.push(result)
            }
          })
          that.allResults = JSON.parse(JSON.stringify(tempResultArray))
        }
        if(that.identifyLayerResult.length !== 0){
          that.identifyLayerResult.forEach(result=>{
            if(result.layerName == item.name){
              tempArray.push(result)
            }
          })
          that.identifyLayerResult = JSON.parse(JSON.stringify(tempArray))
        }
        // mvt的识别
        if (item.type == "mvt") {
          that.showMVTResult(item);
        } else if (item.type == "arcgis") {
          that.showArcgisResult(item);
        } else if (item.type === "3dtiles") {
          that.show3DTilesResult(item, e);
        } else if (item.type === "geojson") {
          that.showGeojsonResult(item, e);
        } else if (item.type === "wms") {
          that.showWMSResult(item);
        }
      });
    },
    // 类型为MVT/PBF的识别
    showMVTResult(layer) {
      const that = this;
      layer.imageryProvider.featuresPicked.addEventListener(function (
        imageryProvider,
        pickedFeatures
      ) {
        // 如果不加这个条件判断也会不管外层的type判断直接执行监听里面的操作
        if (that.polyGraphicLayer.state !== "removed") {
          // 点击获取到的要素（一个） - 需要获取到图层名、标识码和属性
          pickedFeatures[0].layerName = imageryProvider.options.name;
          pickedFeatures[0].layerId = imageryProvider.options.id;
          pickedFeatures[0].attributes = imageryProvider.options.attributes;

          console.log("识别所有层", pickedFeatures, imageryProvider);

          /**
           * start - 初始化图层和识别结果信息
           */
          that.initLayer(
            {
              pickedFeatures: pickedFeatures,
              imageryProvider: imageryProvider,
            },
            "mvt"
          );
          // 所有在地图中加载的【图层】都放在了identifyLayerResult中
          // var layerArr = that.identifyLayerResult.filter(
          //   (result) => result.layerName == pickedFeatures[0].layerName
          // );
          // // 识别的mvt图层的信息
          // if (layerArr.length == 0) {
          //   var obj = {
          //     layerTitle: imageryProvider.options.name,
          //     layerName: imageryProvider.options.name,
          //     serviceUrl: imageryProvider.options.url,
          //   };
          //   that.identifyLayerResult.push(obj);
          // }
          // 这部分的代码不能放到showDetails里，否则allResults就被压入了无限多的item导致异常溢出，因为下拉框也用到了showDetails

          // 得到对应图层的【识别结果/图斑详情】信息
          var identifyData = that.allResults.filter(
            (result) =>
              result.length &&
              result[0].layerName == pickedFeatures[0].layerName
          );
          // 将所有的识别结果信息都放入allResults当中
          if (identifyData.length == 0) {
            that.allResults.push(pickedFeatures);
          } else {
            // 如果找到了对应的图层，那么就在原来的图层基础上把原有的识别结果给替换掉（一个图层只对应一个识别结果）
            that.allResults.forEach(function (result, index) {
              result.length &&
                result[0].layerName == pickedFeatures[0].layerName &&
                that.allResults.splice(index, 1, pickedFeatures);
            });
          }
          /**
           * end
           */

          /**
           * 区分当前层还是所见层（存在selectNode表示当前层，否则则识别所有层）
           */
          if (that.selectedNode) {
            that.resultVisible = true;
            console.log("selectedNode", that.selectedNode);
            if (
              that.identifyLayerResult.length > 0 &&
              that.allResults.length > 0
            ) {
              let currentLayerName = that.identifyLayerResult.filter(function (
                result
              ) {
                return result.layerName == that.selectedNode.dataName;
              })[0].layerName;
              let currentLayerResult = that.allResults.filter(function (
                result
              ) {
                return (
                  result.length && result[0].layerName == that.currentLayer
                );
              })[0];
              that.currentLayer = currentLayerName
                ? currentLayerName
                : that.currentLayer;
              that.currentLayerResult = currentLayerResult
                ? currentLayerResult
                : that.currentLayerResult;
              currentLayerResult &&
                that.showDetails(that.currentLayerResult, imageryProvider);
            }
          } else {
            if (that.identifyLayerResult.length > 0) {
              // 得到目前图层的图层名称（在没有选中的时候默认为第一个图层）
              that.currentLayer = that.identifyLayerResult.filter(
                (result) => result.layerName == pickedFeatures[0].layerName
              )[0].layerName;
            }
            // 得到当前的识别结果（在没有选中的时候默认为第一个图层）
            if (that.identifyLayerResult.length > 0) {
              that.resultVisible = true;
              that.currentLayerResult = that.allResults.filter(
                (result) =>
                  result.length && result[0].layerName == that.currentLayer
              )[0];
              console.log("that.currentLayerResult", that.currentLayerResult);
              that.showDetails(that.currentLayerResult, imageryProvider);
            }
          }
        }
      });
    },
    // 类型为arcgis的识别
    showArcgisResult(layer) {
      var serviceUrl = layer.options.url;
      layer.on(mars3d.EventType.click, (event) => {
        console.log("单击了矢量数据，共" + event.features.length + "条", event);
        this.$refs.detailCard.close();
        // 识别可见层
        this.showData(event.features, serviceUrl, this.selectKey);
      });
    },
    show3DTilesResult(layer, e) {
      const that = this;
      if (!e.pickedObject) {
        that.$refs.detailCard.close();
      }
      // 3dtiles模型暂不支持穿透点击，如果要点选当前层只能渲染一个图层
      if (e.graphic.feature && that.selectedNode.key == layer.options.id) {
        let color = e.pickedObject.color;
        if (that.previousFeature) {
          that.previousFeature.color = color;
        }
        that.previousFeature = e.pickedObject;
        e.pickedObject.color = new Cesium.Color(1, 1, 0, 1);
        let arr = [];
        let attr = e.graphic.attr;
        arr = Object.keys(attr).map((val) => ({
          key: val,
          value: attr[val],
          show: true,
        }));
        that.$refs.detailCard.openDetail(arr, "属性查看");
        if (that.selectedNode) {
          // 将所见层都放入到identifyLayerResult当中
          that.initLayer({ options: layer.options }, "3dtiles");
          // var layerArr = that.identifyLayerResult.filter(
          //   (result) => result.layerName == layer.options.name
          // );
          // if (layerArr.length == 0) {
          //   var obj = {
          //     layerTitle: layer.options.name,
          //     layerName: layer.options.name,
          //     serviceUrl: layer.options.url,
          //   };
          //   that.identifyLayerResult.push(obj);
          // }
          if (that.identifyLayerResult.length > 0) {
            //得到目前图层的图层名称
            that.currentLayer = that.identifyLayerResult.filter(
              (result) => result.layerName == e.layer.options.name
            );
            if (that.currentLayer.length !== 0) {
              that.currentLayer = that.currentLayer[0].layerName;
            }
          }

          // 得到识别结果信息
          var identifyData = that.allResults.filter(
            (result) =>
              result.layerName == e.layer.options.name &&
              result.id == e.layer.options.id
          );
          // 将所有的识别结果信息都放入allResults当中
          if (identifyData.length == 0) {
            item.options.layerName = layer.options.name;
            item.options.pointCoor = e.cartesian;
            that.allResults.push(layer.options);
          }
          // 得到当前的识别结果
          if (that.identifyLayerResult.length > 1) {
            that.resultVisible = true;
            that.currentLayerResult = that.allResults.filter(
              (result) => result.layerName == that.currentLayer
            )[0];
          }
        }
      } else {
        that.$message.warning("识别模型时需要选中该图层！");
      }
      /* 暂时注释
          item.readyPromise.then(function (tileset) {
            console.log("load完成", tileset);
            let boundingSphere = tileset.boundingSphere;
            let cartographic = Cesium.Cartographic.fromCartesian(
              boundingSphere.center
            );
            console.log("cartogrpahic", cartographic);
            let surface = Cesium.Cartesian3.fromRadians(
              cartographic.longitude,
              cartographic.latitude,
              0.0
            );
            let offset = Cesium.Cartesian3.fromRadians(
              cartographic.longitude,
              cartographic.latitude,
              cartographic.height + 200
            );
            var translation = Cesium.Cartesian3.subtract(
              offset,
              surface,
              new Cesium.Cartesian3()
            );
            // item.setOptions({
            //   // style:{
            //     // "color":{
            //     //   "conditions":[
            //     //     ["${id}==='3dtile_feature_7'","color('#ff0000')"],
            //     //     ["true","color('#ffffff')"]
            //     //   ]
            //     // }
            //     // "show" : "${featureIdLabel} === '3dtile_feature_7'",
            //   // },
            //   modelMatrix:Cesium.Matrix4.fromTranslation(translation)
            // })
            // item.setOpacity(0.2)

            // tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation)
            // tileset.updateMatrix2 = function(){
            //   return Cesium.Matrix4.fromTranslation(translation)
            // }
            // console.log('抬升后',tileset);
          });
          
        */
    },
    showGeojsonResult(layer, e) {
      const that = this;
      // 所有在地图中加载的图层都放在了identifyLayerResult中
      if (e.pickedObject) {
        that.initLayer({ options: layer.options }, "geojson");
        // var layerArr = that.identifyLayerResult.filter(
        //   (result) => result.layerName == layer.options.name
        // );
        // if (layerArr.length == 0) {
        //   var obj = {
        //     layerTitle: layer.options.name,
        //     layerName: layer.options.name,
        //     serviceUrl: layer.options.url,
        //   };
        //   that.identifyLayerResult.push(obj);
        // }

        if (that.identifyLayerResult.length > 0) {
          that.currentLayer = that.identifyLayerResult.filter(
            (result) => result.layerName == layer.options.name
          )[0].layerName;
        }

        // 得到识别结果信息
        var identifyData = [];
        if (e.graphics) {
          e.graphics.forEach((graphic) => {
            console.log("graphic", graphic);
            let obj = that.allResults.filter(
              (result) =>
                result.layerName == graphic._layer.options.name &&
                result.layerId == graphic._layer.options.id
            );
            if (obj.length > 1) {
              identifyData.push(obj);
            }
          });
        }
        console.log("识别data", identifyData);
        that.allResults.forEach((result, index) => {
          result.layerName == e.layer.name && that.allResults.splice(index, 1);
        });
        // 将所有的识别结果信息都放入allResults当中
        if (identifyData.length == 0) {
          if (e.graphics) {
            e.graphics.forEach((graphic) => {
              let feature = {
                properties: graphic.options.attr,
                layerId: graphic._layer.options.id,
                layerName: graphic._layer.options.name,
                pointCoor: e.cartesian,
                id: graphic.id,
                attributes: [],
                style: graphic.style,
                type: graphic.type,
                coordinates:
                  graphic.type == "pointP"
                    ? graphic.options.position
                    : graphic.options.instances.find(
                        (instance) => instance.attr == graphic.options.attr
                      ).positions,
                geometry: {
                  coordinates:
                    graphic.type == "pointP"
                      ? [graphic.options.position]
                      : [
                          graphic.options.instances.find(
                            (instance) => instance.attr == graphic.options.attr
                          ).positions,
                        ],
                },
              };
              console.log("feature", feature);
              that.allResults.push(feature);
            });
          } else if (e.pickedObject && e.pickedObject.data) {
            console.log("pickObj", e.pickedObject);
            var feature = {
              properties: e.pickedObject.data.attr,
              layerId: e.layer.id,
              layerName: e.layer.name,
              pointCoor: e.cartesian,
              id: e.id,
              attributes: [],
              style: e.pickedObject.data.style,
              type: e.pickedObject.data.type,
              coordinates: e.pickedObject.data.positions,
              geometry: {
                coordinates: [e.pickedObject.data.positions],
              },
            };
            that.allResults.push(feature);
          } else {
            let feature = {
              properties: e.graphic.options.attr,
              layerId: e.layer.id,
              layerName: e.layer.name,
              pointCoor: e.cartesian,
              id: e.id,
              attributes: [],
              style: e.graphic.options.style,
              type: e.graphic.options.type,
              coordinates:
                e.graphic.options.type == "pointP"
                  ? e.graphic.options.position
                  : e.graphic.options.positions,
              geometry: {
                coordinates:
                  e.graphic.options.type == "pointP"
                    ? [e.graphic.options.position]
                    : [e.graphic.options.positions],
              },
            };
            that.allResults.push(feature);
          }
        }
        // 识别结果数组去重
        let newobj = {};
        that.allResults = that.allResults.reduce((pre, cur) => {
          console.log("cccc", pre, cur);
          newobj[cur.id] ? "" : (newobj[cur.id] = pre.push(cur));
          return pre;
        }, []);
        console.log("qcqcqc", that.allResults);

        // 得到当前的识别结果
        if (that.allResults.length > 0) {
          that.resultVisible = true;
          that.currentLayerResult = that.allResults.filter(
            (result) => result.layerName == that.currentLayer
          );
          that.showDetails(that.currentLayerResult);
        }
      }
    },
    showWMSResult(layer) {
      const that = this;
      layer.on(mars3d.EventType.click, function (event) {
        // that.allResults = []
        if (that.polyGraphicLayer) {
          that.polyGraphicLayer.clear();
        }
        console.log("wms点击事件", event);
        // 所有在地图中加载的图层都放在了identifyLayerResult中
        that.initLayer({ options: layer.options }, "wms");
        // var layerArr = that.identifyLayerResult.filter(function (result) {
        //   return result.layerName == layer.options.name;
        // });
        // if (layerArr.length == 0) {
        //   var obj = {
        //     layerTitle: layer.options.name,
        //     layerName: layer.options.name,
        //     serviceUrl: layer.options.url,
        //   };
        //   that.identifyLayerResult.push(obj);
        // }

        // 得到识别结果信息
        var identifyData = [];
        if (event.features.length > 0) {
          event.features.forEach((feature) => {
            var obj = that.allResults.filter(function (result) {
              return (
                result.length &&
                result[0].layerName == event.layer.options.name &&
                result[0].layerId == event.layer.options.id
              );
            });
            if (obj.length > 1) {
              identifyData.push(obj);
            }
          });
        }

        that.allResults.forEach(function (result, index) {
          result.length &&
            result[0].layerName == event.layer.options.name &&
            that.allResults.splice(index, 1);
        });

        // 将所有的识别结果信息都放入allResults当中
        if (identifyData.length == 0) {
          event.features.forEach(function (feature) {
            feature.data.layerName = layer.options.name;
            feature.data.layerId = layer.options.id;
            feature.data.pointCoor = event.cartesian;
            feature.data.attributes = event.layer.options.attributes;
            that.allResults.push([feature.data]);
          });
        }

        if (that.selectedNode) {
          that.resultVisible = true;
          console.log("selectedNode", that.selectedNode);
          let currentLayerName = that.identifyLayerResult.filter(function (
            result
          ) {
            return result.layerName == that.selectedNode.dataName;
          })[0].layerName;
          let currentLayerResult = that.allResults.filter(function (result) {
            return result[0].layerName == that.currentLayer;
          })[0];
          that.currentLayer = currentLayerName
            ? currentLayerName
            : that.currentLayer;
          that.currentLayerResult = currentLayerResult
            ? currentLayerResult
            : that.currentLayerResult;
          currentLayerResult && that.showDetails(that.currentLayerResult);
        } else {
          if (that.identifyLayerResult.length > 0) {
            // 得到目前图层的图层名称
            console.log(
              "name",
              that.identifyLayerResult.filter(function (result) {
                return result.layerName == layer.options.name;
              })
            );
            that.currentLayer = that.identifyLayerResult.filter(function (
              result
            ) {
              return result.layerName == layer.options.name;
            })[0].layerName;
          }
          if (that.allResults.length > 0) {
            that.resultVisible = true;
            that.currentLayerResult = that.allResults.filter(function (result) {
              return result[0].layerName == that.currentLayer;
            })[0];
            that.showDetails(that.currentLayerResult);
          }
        }
      });
    },
    // 点击识别后获取的所有图层信息
    initLayer(info, type) {
      // 所有在地图中加载的【图层】都放在了identifyLayerResult中
      let layerInfo, layerName;
      if (type == "mvt") {
        layerName = info.pickedFeatures[0].layerName;
        layerInfo = info.imageryProvider.options;
      } else if (type == "arcgis") {
        layerName = info.layerName;
        layerInfo = info;
      } else {
        // 其余类型的做统一处理
        layerName = info.options.name;
        layerInfo = info.options;
      }
      var layerArr = this.identifyLayerResult.filter(
        (result) => result.layerName == layerName
      );
      // 识别的图层的信息
      if (layerArr.length == 0) {
        var obj = {
          layerTitle: layerInfo.name,
          layerName: layerInfo.name,
          serviceUrl: layerInfo.url,
        };
        this.identifyLayerResult.push(obj);
      }
    },
    // arcgis: 把单击识别出来的结果所属的图层归类
    showData(results, serviceUrl, key) {
      const that = this;
      if (results.length > 0) {
        results.map((feature) => {
          // 根据服务地址和图层id 去map.allLayers里匹配该图层，为了获取该图层的别名和属性的显示隐藏

          // 点击识别可见层，图层结果下拉框数据去重（根据图层名）
          that.initLayer({
            layerName: feature.data.layerName,
            name: feature.data.layerName,
            url: serviceUrl,
          });
          // var layerArr = this.identifyLayerResult.filter(
          //   (result) => result.layerName == feature.data.layerName
          // );

          // if (layerArr.length == 0 && feature.name) {
          //   // 不存在，就新增
          //   var obj = {
          //     layerTitle: feature.data.layerName,
          //     layerName: feature.data.layerName,
          //     serviceUrl: serviceUrl,
          //   };
          //   this.identifyLayerResult.push(obj);
          // }

          // 连续识别的话需要将上一个识别结果移除
          this.allResults.forEach((result, index) => {
            result.data &&
              result.data.layerName == feature.data.layerName &&
              this.allResults.splice(index, 1);
          });

          // 识别出来的所有结果里有重复，需去重(通过图层名称和OBJECTID判断)
          var identifyData = this.allResults.filter(
            (result) =>
              result.data &&
              result.data.layerName == feature.data.layerName &&
              result.data.attributes.OBJECTID ==
                feature.data.attributes.OBJECTID
          );

          if (identifyData.length == 0) {
            this.allResults.push(feature);
          }
        });
      }
      this.resultVisible = true;
      if (this.selectedNode) {
        this.selectDefaultLayer(this.selectedNode);
      } else {
        this.selectDefaultLayer();
      }
    },

    // 识别以后，默认选中一个图层，如果该图层只有一个结果，直接定位
    selectDefaultLayer(selectedNode) {
      if (map.graphicLayer) {
        // 框选的形状  清除
        map.graphicLayer.clear();
      }
      if (this.graphicLayer) {
        // 定位以后的高亮  清除
        this.graphicLayer.remove();
      }

      if (this.identifyLayerResult.length > 0) {
        if (selectedNode) {
          this.currentLayer = this.identifyLayerResult.filter(function (
            result
          ) {
            return result.layerName == selectedNode.dataName;
          })[0].layerName;
        } else {
          this.currentLayer = this.identifyLayerResult[0].layerTitle;
        }

        this.currentLayerResult = this.allResults.filter(
          (result) => result.data && result.data.layerName == this.currentLayer
        );

        this.doPosition(this.currentLayerResult[0], { isPopup: true }, false);
      }
    },
    // 点击表格按钮定位
    doPosition(item, queryParams, flyTo) {
      // console.log('doPosition',item,queryParams);
      if (queryParams && queryParams.isPopup) {
        if (item.attributes && item.attributes.length > 0) {
          this.$refs.detailCard.openDetail(
            item.attributes,
            item.data.attributes.OBJECTID || ""
          );
        } else {
          var list = item.properties;
          var array = [];
          array = Object.keys(list).map((val) => ({
            key: val,
            value: list[val],
            show: true,
          }));
          this.$refs.detailCard.openDetail(
            array,
            item.properties.OBJECTID || ""
          );
          // this.$message.warning('该图层暂无属性')
        }
      } else {
        this.$refs.detailCard.close();
      }
      // 点击识别，坐标在item.data.geometry.rings里且需要 3857转4326；    框选识别，坐标在item.geometry.coordinates，直接是经纬度不用转换
      var lngLatArr = item.data.geometry
        ? item.data.geometry.rings[0]
        : // ? transformCrsCoordinate( item.data.geometry.rings[0], 3857 )
          item.geometry.coordinates[0];
      this.flyToLnglatsAndHighlight(
        this.polyGraphicLayer,
        lngLatArr,
        0.8,
        flyTo
      );
    },
    showDetails(item) {
      console.log("pickfeautres", item);
      if (item && item.length > 0) {
        if (this.polyGraphic) {
          this.polyGraphicLayer.removeGraphic(this.polyGraphic);
        }
        if(this.wmsLightLayer){
          map.removeLayer(this.wmsLightLayer)
        }
        if(this.geojsonLayerT){
          map.removeLayer(this.geojsonLayerT);
        }
        map.closeHighlight(); // 主要是为了清除geojson自带的高亮
        var list = item[0].properties;
        var array = [];
        let attributeArr = [];
        array = Object.keys(list).map((val) => ({
          key: val,
          value: list[val],
          show: true,
        }));
        if (item[0].attributes && item[0].attributes.length > 0) {
          array.forEach((arr) => {
            item[0].attributes.forEach((attr) => {
              if (arr.key == attr.name.toLowerCase()) {
                let obj = {
                  key: arr.key,
                  value: arr.value,
                  show: arr.show,
                  alias: attr.alias,
                  orderNo: attr.orderNo,
                  type: "mvt",
                };
                attributeArr.push(obj);
              }
              // console.log('attr.name.toLowerCase()',attr.name.toLowerCase(),arr.key,arr.key == attr.name.toLowerCase());
              // arr.alias = arr.key == attr.name.toLowerCase() ? attr.alias : arr.key
              // arr.orderNo = attr.orderNo
            });
          });
        } else {
          attributeArr = array;
        }
        // console.log('键值对数组',attributeArr)

        this.$refs.detailCard.openDetail(attributeArr, `${item[0].layerName}`);
        let url = this.identifyLayerResult.filter(layer=>layer.layerName === item[0].layerName)[0].serviceUrl
        if(url.includes('jzq')){        
          console.log('serviceUrl',url.split('gwc'));
          this.wmsLightLayer = new mars3d.layer.WmsLayer({
            url: `${url.split('gwc')[0]}${url.split('/')[8].split('%3A')[0]}/wms`,
            layers: `${url.split('/')[8].split('%3A')[0]}:${url.split('/')[8].split('%3A')[1].split('@')[0]}`,
            parameters: {
              version:'1.1.1',
              request: 'GetMap',
              format: "image/png",
              transparent: true,
              cql_filter: `zcqcbsm = '${item[0].properties.zcqcbsm}'`,
              styles:'f_nydjzq',
            },
            getCapabilities:false,
            opacity:0.5
          })
          map.addLayer(this.wmsLightLayer)
          return
        }
        item.forEach((graphic) => {
          console.log("string", JSON.stringify(graphic.properties));
          if (graphic.type && graphic.type == "pointP") {
            this.polyGraphic = new mars3d.graphic.PointEntity({
              position: new mars3d.LngLatPoint(
                graphic.coordinates[0],
                graphic.coordinates[1]
              ),
              style: {
                color: graphic.style.highlight.color,
                opacity: graphic.style.highlight.opacity,
                outline: graphic.style.highlight.outline,
                outlineWidth: graphic.style.highlight.outlineWidth,
                outlineColor: graphic.style.highlight.outlineColor,
                outlineOpacity: graphic.style.highlight.outlineOpacity,
                pixelSize: graphic.style.pixelSize,
                clampToGround: true,
              },
            });
          } else if (graphic.type && graphic.type == "polylineP") {
            this.polyGraphic = new mars3d.graphic.PolylineEntity({
              positions: graphic.geometry.coordinates[0],
              style: {
                color: graphic.style.highlight.color,
                opacity: graphic.style.highlight.opacity,
                width: graphic.style.highlight.width,
                clampToGround: true,
              },
            });
          } else {
            // 返回的结果会出现多面的情况，用PolygonEntity只能展示一个面
            this.geojsonLayerT = new mars3d.layer.GeoJsonLayer({
              data: graphic,
              symbol:{
                type:'polygonP',
                styleOptions:{
                  color: "#3388ff",
                  opacity: 0.3,
                  outline: true,
                  outlineWidth: 2,
                  outlineColor: "#3388ff",
                  clampToGround: true
                }
              }
            })
            map.addLayer(this.geojsonLayerT)
            // this.polyGraphic = new mars3d.graphic.PolygonEntity({
            //   positions: graphic.geometry.coordinates[0],
            //   style: {
            //     color: "#3388ff",
            //     opacity: 0.3,
            //     outline: true,
            //     outlineWidth: 2,
            //     outlineColor: "#3388ff",
            //     label: {
            //       text: "",
            //       font_size: 18,
            //       color: "#ffffff",
            //       distanceDisplayCondition: true,
            //       distanceDisplayCondition_far: 500000,
            //       distanceDisplayCondition_near: 0,
            //     },
            //     clampToGround: true,
            //   },
            // });
          }
          this.polyGraphic && this.polyGraphicLayer.addGraphic(this.polyGraphic);
        });
      } else {
        this.$refs.detailCard.close();
      }
    },
    showWaterDetails(arr, positions) {
      this.$refs.detailCard.openDetail(arr, "水面属性查看");

      if (map.graphicLayer) {
        // 框选的形状  清除
        map.graphicLayer.clear();
      }
      if (this.graphicLayer) {
        // 定位以后的高亮  清除
        this.graphicLayer.remove();
      }

      this.graphicLayer = new mars3d.layer.GraphicLayer();
      map.addLayer(this.graphicLayer);
      let graphic = new mars3d.graphic.PolygonEntity({
        positions: positions,
        style: {
          color: "#3388ff",
          opacity: 0.3,
          outline: true,
          outlineWidth: 2,
          outlineColor: "#3388ff",
        },
      });
      this.graphicLayer.addGraphic(graphic);
    },
    // 根据经纬度坐标数组定位并高亮
    flyToLnglatsAndHighlight(graphicLayer, positions, time, flyTo) {
      if (this.polyGraphic) {
        this.polyGraphicLayer.removeGraphic(this.polyGraphic);
      }
      this.polyGraphic = new mars3d.graphic.PolygonEntity({
        positions: positions,
        style: {
          color: "#3388ff",
          opacity: 0.3,
          outline: true,
          outlineWidth: 2,
          outlineColor: "#3388ff",
          label: {
            text: "",
            font_size: 18,
            color: "#ffffff",
            distanceDisplayCondition: true,
            distanceDisplayCondition_far: 500000,
            distanceDisplayCondition_near: 0,
          },
          clampToGround: true,
        },
      });
      this.polyGraphicLayer.addGraphic(this.polyGraphic);
      // 定位(方法二)
      if (flyTo) {
        this.polyGraphic.flyTo({
          scale: 3,
          duration: time,
        });
      }
    },
    // 切换结果图层下拉框
    handleSelect(value, option) {
      // console.log('选择下拉框',value,option);
      // console.log('this.allResults',this.allResults,this.currentLayerResult);
      // 清除矢量图层并新建一个，添加到地图上，不清除页面上会重复叠加
      if (this.polyGraphic) {
        this.polyGraphicLayer.removeGraphic(this.polyGraphic);
      }
      this.currentLayer = option.data.attrs.info.layerTitle;
      this.currentLayerUrl = option.data.attrs.info.serviceUrl;
      var layerName = option.data.attrs.info.layerName;
      if (this.currentLayerUrl.includes("pbf")) {
        this.currentLayerResult = this.allResults.filter(
          (result) => result.length && result[0].layerName == layerName
        )[0];
        console.log("currentLayerResult", this.currentLayerResult);
        this.showDetails(this.currentLayerResult);
      } else if (this.currentLayerUrl.includes("wms")) {
        if (this.polyGraphicLayer) {
          this.polyGraphicLayer.clear();
        }
        this.currentLayerResult = this.allResults.filter(function (result) {
          return result.length && result[0].layerName == layerName;
        })[0];
        console.log("currentLayerResult2", this.currentLayerResult);
        this.showDetails(this.currentLayerResult);
        // var arr = [];
        // var attr = this.currentLayerResult[0].properties;
        // arr = Object.keys(attr).map(function (val) {
        //   return {
        //     key: val,
        //     value: attr[val],
        //     show: true
        //   };
        // });
        // this.$refs.detailCard.openDetail(arr, "属性查看");
        //   this.polyGraphic = new mars3d.graphic.PolygonEntity({
        //     positions: this.currentLayerResult[0].geometry.coordinates[0],
        //     style: {
        //       color: "#3388ff",
        //       opacity: 0.3,
        //       outline: true,
        //       outlineWidth: 2,
        //       outlineColor: "#3388ff",
        //       label: {
        //         text: "",
        //         font_size: 18,
        //         color: "#ffffff",
        //         distanceDisplayCondition: true,
        //         distanceDisplayCondition_far: 500000,
        //         distanceDisplayCondition_near: 0,
        //       },
        //       clampToGround: true,
        //     },
        //   });
        //   this.polyGraphicLayer.addGraphic(this.polyGraphic);
      } else if (this.currentLayerUrl.includes("WFS")) {
        if (this.polyGraphicLayer) {
          this.polyGraphicLayer.clear();
        }
        this.currentLayerResult = this.allResults.filter(
          (result) => result.layerName == this.currentLayer
        );
        console.log("currentLayerResult2", this.currentLayerResult);
        this.showDetails(this.currentLayerResult);
        /*
        let arr = [];
        let attr = this.currentLayerResult[0].properties;
        arr = Object.keys(attr).map((val) => ({
          key: val,
          value: attr[val],
          show: true,
        }));
        this.$refs.detailCard.openDetail(arr, "属性查看");
        if(this.currentLayerResult[0].type == 'pointP'){
          this.polyGraphic = new mars3d.graphic.PointEntity({
            position: new mars3d.LngLatPoint(this.currentLayerResult[0].coordinates[0], this.currentLayerResult[0].coordinates[1]) ,
            style: {
              color: this.currentLayerResult[0].style.highlight.color,
              opacity: this.currentLayerResult[0].style.highlight.opacity,
              outline: this.currentLayerResult[0].style.highlight.outline,
              outlineWidth: this.currentLayerResult[0].style.highlight.outlineWidth,
              outlineColor: this.currentLayerResult[0].style.highlight.outlineColor,
              outlineOpacity: this.currentLayerResult[0].style.highlight.outlineOpacity,
              pixelSize: this.currentLayerResult[0].style.pixelSize,
              clampToGround: true,
            },
          });
          this.polyGraphicLayer.addGraphic(this.polyGraphic);
        }else {
          this.polyGraphic = new mars3d.graphic.PolygonEntity({
            positions: this.currentLayerResult[0].coordinates,
            style: {
              color: this.currentLayerResult[0].style.highlight.color,
              opacity: this.currentLayerResult[0].style.highlight.opacity,
              outline: this.currentLayerResult[0].style.highlight.outline,
              outlineWidth: this.currentLayerResult[0].style.highlight.outlineWidth,
              outlineColor: this.currentLayerResult[0].style.highlight.outlineColor,
              outlineOpacity: this.currentLayerResult[0].style.highlight.outlineOpacity,
              clampToGround: true,
            },
          });
          this.polyGraphicLayer.addGraphic(this.polyGraphic);
        }
        console.log('选择之后高亮',identifyResultvue_type_script_lang_js_map.getLayers()); */
      } else if (this.currentLayerUrl.includes("arcgis")) {
        this.currentLayerResult = this.allResults.filter(
          (result) => result.data && result.data.layerName == layerName
        );
        // 如果选中的图层只有一条数据，直接定位
        if (this.currentLayerResult.length == 1) {
          this.doPosition(this.currentLayerResult[0], { isPopup: true }, false);
        } else {
          // this.clearAll();
          if (this.polyGraphic) {
            this.polyGraphicLayer.removeGraphic(this.polyGraphic);
          }
        }
      }
    },
    // 清除数据
    clearAll(key) {
      // 框选后返回的数据  清空
      drawGraphic = null;
      if (key) {
        this.selectKey = "";
        this.selectedNode = null;
        this.handleClose();
        // console.log('clear',this.selectKey,this.selectedNode,this.resultVisible);
      }

      if (this.mousedownFunction) {
        map.off(mars3d.EventType.click);
      }
      if (this.graphicLayer) {
        // 定位以后的高亮  从地图上移除
        this.graphicLayer.remove();
      }
      if (this.selectedGeom) {
        //水面的高亮
        map.scene.primitives.remove(this.selectedGeom);
      }
      if (this.polyGraphicLayer) {
        // 定位以后的高亮  从地图上移除
        this.polyGraphicLayer.remove();
      }
      if (map && map.graphicLayer) {
        // 框选的形状  清除图层里的数据S
        map.graphicLayer.clear();
      }
      if (geoJsonLayer) {
        // 框选到的所有区域高亮  从地图上移除
        geoJsonLayer.remove();
      }
      // 清除高亮
      if (this.wmsLightLayer) {
        map.removeLayer(this.wmsLightLayer);
      }
      if(this.geojsonLayerT){
        map.removeLayer(this.geojsonLayerT);
      }
      if (map) {
        console.log("map", map.getLayers());
        map.getLayers().forEach((item) => {
          item.closeHighlight();
        });
      }
    },
    // 关闭弹框以及属性弹窗
    handleClose() {
      this.resultVisible = false;
      if (this.$refs.detailCard) {
        this.$refs.detailCard.close();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.identifyResult {
  position: absolute;
  top: 45px;
  right: 510px;
}
.container {
  width: 400px;
  height: 250px !important;
  z-index: 1;
  backdrop-filter: blur(15px);
  .ant-list-item-meta-title {
    margin-bottom: 0px;
    span {
      color: #fff;
      padding-left: 10px;
    }
  }
  .identify-result {
    border: 0;
    height: 100%;
    .boxClose {
      position: absolute;
      top: 4%;
      right: 2%;
    }
    .selectBox {
      /deep/ .ant-select-dropdown {
        background: rgba(255, 255, 255, 0.5);
        backdrop-filter: blur(15px);
      }

      /deep/.ant-select-dropdown-menu {
        color: rgba(255, 255, 255, 0.5);
      }

      /deep/.ant-select-dropdown-menu-item {
        color: rgba(255, 255, 255, 0.5);
      }
      /deep/.ant-select-dropdown-menu-item:hover {
        color: #ffffff !important;
      }
      /deep/.ant-select-dropdown-menu-item-selected {
        color: #ffffff !important;
      }
      /deep/.ant-select-dropdown-menu-item-active {
        color: #ffffff !important;
      }
    }

    /deep/.ant-col-6 {
      width: 16%;
    }
    /deep/.ant-list-item {
      background: rgba(255, 255, 255, 0.2);
      margin: 2%;
      border: 0px solid rgba(255, 255, 255, 0.2);
    }
    /deep/.ant-select-selection {
      background-color: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.5);
    }
  }
  /deep/.ant-card-head-wrapper {
    background: transparent;
  }
  /deep/ .ant-card-head {
    padding: 0 10px;
    background-color: transparent;
    height: 45px;
    border: 0;
  }
  /deep/ .ant-card-head-wrapper {
    height: 100%;
  }
  /deep/ .ant-card-body {
    padding: 10px;
    height: calc(100% - 45px);
  }
  /deep/ .ant-form-item {
    margin-bottom: 6px;
  }
  /deep/ .search-result-list {
    overflow: auto;
    height: calc(100% - 54px);
    background: rgba(255, 255, 255, 0.1) !important;
  }
}
// 隐藏拖拽弹框的小圆圈，并调整位置
/deep/ .ant-card-head:hover {
  cursor: move;
}
/deep/ .handle {
  opacity: 0;
}
/deep/ .handle-tl {
  top: -5px;
  left: -5px;
}
/deep/ .handle-tr {
  top: -5px;
  right: -5px;
}
/deep/ .handle-bl {
  bottom: -5px;
  left: -5px;
}
/deep/ .handle-br {
  bottom: -5px;
  right: -5px;
}
/deep/.ant-list-item-action {
  margin-right: 2%;
}
/deep/.ant-list-item-action > li {
  padding: 0 4px;
}
/deep/.ant-list-item-action-split {
  background-color: transparent;
}
</style>